import React from "react";

const EpSessionFilters = ({
  search,
  setSearch,
  filterType,
  setFilterType,
  filterDetection,
  setFilterDetection,
  filterPresence,
  setFilterPresence,
  filterDecision,
  setFilterDecision,
  filterDirectorDecision,
  setFilterDirectorDecision,
  filterAlert,
  setFilterAlert,
  sortBy,
  setSortBy,
  sortDir,
  setSortDir,
  totalCount,
  filteredCount,
}) => {
  const isDirectorView = setFilterDirectorDecision !== undefined;
  const hasActiveFilters =
    search ||
    filterType !== "" ||
    filterDetection !== "" ||
    filterPresence !== "" ||
    filterDecision !== "" ||
    filterDirectorDecision !== "" ||
    filterAlert !== "";

  const clearAll = () => {
    setSearch("");
    setFilterType("");
    setFilterDetection("");
    setFilterPresence("");
    setFilterDecision("");
    if (setFilterDirectorDecision) setFilterDirectorDecision("");
    setFilterAlert("");
    setSortBy("index");
    setSortDir("asc");
  };

  const selectStyle = {
    fontSize: 12,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    padding: "6px 10px",
    color: "#334155",
    background: "#fff",
    cursor: "pointer",
    minWidth: 0,
  };

  const activeSelectStyle = (value) =>
    value
      ? { ...selectStyle, borderColor: "#3b82f6", background: "#eff6ff" }
      : selectStyle;

  return (
    <div
      data-tour="filters"
      className="rounded mb-3"
      style={{
        background: "#fff",
        border: "1px solid #e2e8f0",
        overflow: "hidden",
      }}
    >
      {/* Search + sort row */}
      <div
        className="d-flex align-items-center p-3"
        style={{ gap: 10, borderBottom: "1px solid #f1f5f9" }}
      >
        <div
          className="d-flex align-items-center justify-content-center flex-shrink-0"
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
          }}
        >
          <i className="fa fa-filter" style={{ fontSize: 13, color: "#fff" }} />
        </div>
        <div style={{ position: "relative", flex: 1, maxWidth: 280 }}>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="🔎 Rechercher par nom..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              fontSize: 13,
              borderRadius: 8,
              paddingRight: 30,
              paddingLeft: 32,
            }}
          />

          {search && (
            <button
              onClick={() => setSearch("")}
              style={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#94a3b8",
                fontSize: 14,
                padding: 0,
                lineHeight: 1,
              }}
            >
              <i className="fa fa-times" />
            </button>
          )}
        </div>

        <div
          style={{ marginLeft: "auto" }}
          className="d-flex align-items-center"
        >
          <span
            style={{
              fontSize: 11,
              color: "#94a3b8",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: 0.5,
              marginRight: 6,
              whiteSpace: "nowrap",
            }}
          >
            Trier par
          </span>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            style={{ ...selectStyle, marginRight: 4 }}
          >
            <option value="index">Ordre d'inscription</option>
            <option value="name">Nom</option>
            <option value="type">Type de sanction</option>
            <option value="detection">Détection</option>
            <option value="decision">Statut décision</option>
          </select>
          <button
            onClick={() => setSortDir((d) => (d === "asc" ? "desc" : "asc"))}
            title={sortDir === "asc" ? "Croissant" : "Décroissant"}
            style={{
              background: "#f1f5f9",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              width: 32,
              height: 32,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "#475569",
              fontSize: 13,
              flexShrink: 0,
            }}
          >
            <i
              className={`fa fa-sort-amount-${sortDir === "asc" ? "up" : "down"}`}
            />
          </button>
        </div>
      </div>

      {/* Filter chips row */}
      <div
        className="d-flex align-items-center flex-wrap px-3 py-2"
        style={{ gap: 8 }}
      >
        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          style={activeSelectStyle(filterType)}
        >
          <option value="">Type de sanction</option>
          <option value="SUSPENSION">Suspension</option>
          <option value="SUPPRESSION">Suppression</option>
        </select>

        <select
          value={filterDetection}
          onChange={(e) => setFilterDetection(e.target.value)}
          style={activeSelectStyle(filterDetection)}
        >
          <option value="">Détection</option>
          <option value="PREMIER">Premier manquement</option>
          <option value="PERSISTANCE">Persistance</option>
          <option value="REITERATION">Réitération</option>
        </select>

        <select
          value={filterPresence}
          onChange={(e) => setFilterPresence(e.target.value)}
          style={activeSelectStyle(filterPresence)}
        >
          <option value="">Présence</option>
          <option value="present">Présent(e)</option>
          <option value="absent">Absent(e)</option>
          <option value="absent_observations">Absent, observations écrites</option>
          <option value="non_convoque">Non convoqué</option>
          <option value="none">Non renseigné</option>
        </select>

        <select
          value={filterDecision}
          onChange={(e) => setFilterDecision(e.target.value)}
          style={activeSelectStyle(filterDecision)}
        >
          <option value="">Décision</option>
          <option value="with">Avec décision</option>
          <option value="without">Sans décision</option>
        </select>

        {isDirectorView && (
          <select
            value={filterDirectorDecision}
            onChange={(e) => setFilterDirectorDecision(e.target.value)}
            style={activeSelectStyle(filterDirectorDecision)}
          >
            <option value="">Décision directeur</option>
            <option value="ACCORD">Accord</option>
            <option value="A_SURSEOIR">À surseoir</option>
            <option value="none">Sans décision</option>
          </select>
        )}

        <select
          value={filterAlert}
          onChange={(e) => setFilterAlert(e.target.value)}
          style={activeSelectStyle(filterAlert)}
        >
          <option value="">Alertes</option>
          <option value="over62">+62 ans</option>
          <option value="pregnancy">Grossesse</option>
        </select>

        {hasActiveFilters && (
          <button
            onClick={clearAll}
            className="d-flex align-items-center"
            style={{
              background: "#fef2f2",
              border: "1px solid #fecaca",
              borderRadius: 8,
              padding: "5px 12px",
              fontSize: 12,
              color: "#dc2626",
              fontWeight: 600,
              cursor: "pointer",
              gap: 5,
            }}
          >
            <i className="fa fa-times" style={{ fontSize: 10 }} />
            Réinitialiser
          </button>
        )}

        <div
          style={{
            marginLeft: "auto",
            fontSize: 12,
            color: "#64748b",
            fontWeight: 500,
          }}
        >
          {filteredCount !== totalCount ? (
            <span>
              <strong style={{ color: "#2563eb" }}>{filteredCount}</strong> /{" "}
              {totalCount} allocataire(s)
            </span>
          ) : (
            <span>{totalCount} allocataire(s)</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EpSessionFilters;
